import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Modal } from '@mui/material';
import { Theme } from '@/shared/theme';
import { BorisScreener } from '@/shared/borisScreenerTheme';
import CloseCross from '@/assets/images/close-cross.svg';

type LinkModalProps = {
  open: boolean;
  onClose: () => void;
  src: string;
  title: string;
};

const IframeContainer = styled.div`
  width: ${Theme.Dimensions.c10}px;
  height: 85vh;
  border: none;
  padding: 0;
  margin: 0;
  position: absolute;
  align-items: center;
  justify-content: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 16px;
  background: ${BorisScreener.coral};
`;

const StyledIframe = styled.iframe`
  width: ${Theme.Dimensions.c10}px;
  height: 85vh;
  border: none;
  border-radius: 16px;
  background: ${BorisScreener.coral};
`;

const CloseButton = styled.button`
  position: absolute;
  top: ${Theme.Spacing.x2}px;
  right: ${Theme.Spacing.x2}px;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 1;
`;

const ButtonRow = styled.div`
  background-color: ${BorisScreener.coral};
  width: 100%;
  height: 40px;
  border-radius: 16px;
`;

const ButtonWrapper = styled.div`
  position: absolute;
  background-color: ${BorisScreener.coral};
  width: 100%;
  height: 45px;
  border-radius: 16px;
`;

const LinkModal: React.FC<LinkModalProps> = ({ open, onClose, src, title }) => {
  const [iframeLoaded, setIframeLoaded] = useState(false);

  useEffect(() => {
    if (open && !iframeLoaded) {
      setIframeLoaded(true);
    }
  }, [open, iframeLoaded]);

  return (
    <Modal open={open} onClose={onClose}>
      <IframeContainer>
        <ButtonRow>
          <ButtonWrapper>
            <CloseButton onClick={onClose} aria-label="Close">
              <img src={CloseCross} alt="Close" />
            </CloseButton>
          </ButtonWrapper>
        </ButtonRow>
        {iframeLoaded && <StyledIframe src={src} title={title} />}
      </IframeContainer>
    </Modal>
  );
};

export { LinkModal };
